import { createSlice } from '@reduxjs/toolkit';

import { SORT_ASC, SORT_BY_DEFAULT, SORT_DESC } from '@/modules/common/constants/sorting';

type StateProps = {
  sortBy?: string;
  sortOrder?: typeof SORT_DESC | typeof SORT_ASC;
};

const initialState: StateProps = {
  sortBy: SORT_BY_DEFAULT,
  sortOrder: SORT_DESC,
};

/** https://immerjs.github.io/immer/update-patterns/ */
export const slice = createSlice({
  name: 'channelCommon',
  initialState,
  reducers: {
    setSortByAction: (state, action) => {
      state.sortBy = action.payload;
    },
    setSortOrderAction: (state, action) => {
      state.sortOrder = action.payload;
    },
  },
});

export const { setSortByAction, setSortOrderAction } = slice.actions;
